import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

const STORAGE_KEY = 'xceedEdge_user';
const AUTH_KEY = 'xceedEdge_authenticated';

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoadingAuth, setIsLoadingAuth] = useState(true);
  const [isLoadingPublicSettings, setIsLoadingPublicSettings] = useState(true);
  const [authError, setAuthError] = useState(null);
  const [appPublicSettings, setAppPublicSettings] = useState(null);

  // Load user from localStorage on mount
  useEffect(() => {
    checkAppState();
  }, []);

  const checkAppState = async () => {
    try {
      // Load user and auth state from localStorage
      const storedUser = localStorage.getItem(STORAGE_KEY);
      const storedAuth = localStorage.getItem(AUTH_KEY);
      
      if (storedUser) {
        setUser(JSON.parse(storedUser));
        setIsAuthenticated(storedAuth === 'true');
      }
    } catch (err) {
      console.error('Error loading user from localStorage:', err);
    } finally {
      setIsLoadingPublicSettings(false);
      setIsLoadingAuth(false);
    }
  };

  const setUserData = (userData) => {
    setUser(userData);
    if (userData) {
      setIsAuthenticated(true);
      // Save to localStorage
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(userData));
        localStorage.setItem(AUTH_KEY, 'true');
      } catch (err) {
        console.error('Error saving user to localStorage:', err);
      }
    }
  };

  const getUser = () => {
    return user;
  };

  const logout = () => {
    setUser(null);
    setIsAuthenticated(false);
    // Clear localStorage
    try {
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem(AUTH_KEY);
    } catch (err) {
      console.error('Error clearing localStorage:', err);
    }
  };

  const navigateToLogin = () => {
    console.warn('navigateToLogin is not configured.');
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser: setUserData,
        getUser,
        isAuthenticated,
        isLoadingAuth,
        isLoadingPublicSettings,
        authError,
        appPublicSettings,
        logout,
        navigateToLogin,
        checkAppState,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
